// src/utils/blockedUrls.js
export const noAuthCheckUrls = [
    '/findId',
    '/findPw',
    '/login',
    '/join',
    '/agree',
    '/cert',
    '/util/checkSuccess',
    '/member/register',
    '/member/complete',
    '/member/sleep',
    '/member/pwChange',
    '/member/lastPwChange'
];